// utils/formatters.js
export const formatCurrency = (amount) => {
    if (amount === undefined || amount === null || Number.isNaN(amount)) {
        return '$0.00';
    }
    return `$${Number(amount).toFixed(2)}`;
};

export const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};
